<div
  *ngIf="!hideOnInitPage"
  class="call-history-filter-popup"
  [ngClass]="{ 'call-history-filter-popup-open': open, 'call-history-filter-popup-close': !open }">
  <div class="call-history-filter-popup__head">
    <h3 class="vox-heading-3">{{ "events.company-call-history.filters.popup.title" | Translate }}</h3>
    <button class="call-history-filter-popup__head-actions-btn">
      <i
        class="icon-small-close"
        (click)="close()"></i>
    </button>
  </div>
  <div class="call-history-filter-popup__body">
    <app-call-history-filters
      [closePopup]="closingPopup"
      (selectedFilters)="onFiltersChange($event)"></app-call-history-filters>
  </div>
</div>
